import type { EmotionJSX } from "@emotion/react/dist/declarations/src/jsx-namespace";
import type { ComponentType } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { FallbackSignUpButton } from "./fallback-sign-up-button";

export function withFallback<Props extends object>(Component: ComponentType<Props>) {
  const WrappedComponent = (props: Props) => (
    <ClientSideSuspense fallback={<FallbackSignUpButton />}>
      <Component {...(props as EmotionJSX.LibraryManagedAttributes<typeof Component, Props>)} />
    </ClientSideSuspense>
  );
  return WrappedComponent;
}
